import axios from 'axios';
import { ShareSurvey, UserEntity } from '@/types';

export const fetchShareSurvey = async (uuid: string) => {
  const { data } = await axios.get<ShareSurvey>(`/share_surveys/${uuid}`);
  return data;
};

export const fetchShareSurveyOwners = async () => {
  const { data } = await axios.get<Array<UserEntity>>('/share_surveys/owners');
  return data;
};

export const putShareSurvey = async (
  uuid: string,
  options: {
    shareSurveyUserIds?: Array<number>;
    isAllUsersAccessible?: boolean;
    expiredAt?: Date;
    title?: string;
  },
) => {
  const requestBody: Record<string, unknown> = {};

  if (options.shareSurveyUserIds !== undefined)
    requestBody.share_survey_user_ids = options.shareSurveyUserIds;
  if (options.isAllUsersAccessible !== undefined)
    requestBody.is_all_users_accessible = options.isAllUsersAccessible;
  if (options.expiredAt !== undefined)
    requestBody.expired_at = options.expiredAt;
  if (options.title !== undefined) requestBody.title = options.title;

  const { data } = await axios.put<ShareSurvey>(
    `/share_surveys/${uuid}`,
    requestBody,
  );
  return data;
};

export const postShareSurvey = async (surveyUuid: string) => {
  const { data } = await axios.post<ShareSurvey>('/share_surveys', {
    survey_uuid: surveyUuid,
  });
  return data;
};

export const deleteShareSurvey = async (uuid: string) => {
  const { data } = await axios.delete<ShareSurvey>(`/share_surveys/${uuid}`);
  return data;
};
